import services from './../../services/service'; // Service Class
import MainHeader from './../MainHeader/index.vue'; // Main Header
import MainFooter from './../MainFooter/index.vue'; // Main Footer
//
//import DeliveryLocations from './../Components/DeliveryLocations'
//
import AccountResources from './../Account/Resources/commonfunctions.js';

//
let service = new services();

export default {
    name: 'PlacedOrders',
    mixins: [AccountResources],
    data () {
        return {
            //
            headerdata:{
                'name':'Placed Order',
            },
        }
    },
    components: {
        'component-header': MainHeader,
        'component-footer': MainFooter,
       // 'component-delivery-locations': DeliveryLocations
    },
    methods: {

        preset() {
            this.loading = true;
            
            //../
            let self = this;
            localforage.getItem(service.udb_name, function(err, value) { //quick with the callback version
                if(value != undefined) {
                    self.user = value;
                    //
                    self.getOrders(self.user.user_id);
                }else {
                    self.loading = false;
                    self.$router.push('/login')
                }
            });
            
        },
},
created: function(){
    this.preset();
}
}



// WEBPACK FOOTER //
// ./src/pages/PlacedOrders/script.js